<template>
	<div class="connect_to_stripe_box" :class="{'in-progress': loadingConnection}" >
		<v-button :loading="loading" border label="Disconnect" class="disconect_btn" @click="disconnectThisGateway"
		          v-if="userGatewayConfig.is_connected == true" />

		<h3>Connect to Stripe</h3>
		<div class="connect_to_stripe_box_innner has_been_connected" v-if="userGatewayConfig.is_connected == true">
			<p>Your Stripe account has been connected to Funnelish™.</p>
			<a class="btn btn_green">
				<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true" data-icon="check" data-prefix="fas" id="ember3597" class="svg-inline--fa fa-check fa-w-16  undefined ember-view" style="width: 15px;">
					<path fill="currentColor" d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
				</svg> Connected
			</a>
		</div>
		<div class="connect_to_stripe_box_innner connect" v-else>
			<p>Click the <b>"Connect"</b> button below to link your Stripe account to Funnelish.</p>
			<v-button :loading="loading" :disabled="!userGateway.name" @click="connectThisGateway">
				Connect
			</v-button>
		</div>
		<div class="loading-connection" v-if="loadingConnection">
			<v-spinner />
		</div>
	</div>
</template>

<script>
import VButton from "@/components/base/v-button";
import VSpinner from "@/components/base/v-spinner";
import API from "@/api";
export default {
name: "fpay-stripe-settings",
	components: {VSpinner, VButton},
	props: ['currentGroup', 'userGatewayConfig', 'userGateway', 'isEditing'],
	mixins: [API],

	data: function (){
		return {
			loading: false,
			loadingConnection: false,
		}
	},
	methods:{
		goBack() {
			this.$emit('goBack');
		},
		openUrl(url, userGatewayId) {
			this.loadingConnection = true;
			var win = window.open(url, "Connect gateway");
			var timer = setInterval(()=>{
				if (!win || win.closed) {
					clearInterval(timer);
					this.afterConnection(userGatewayId);
				}
			}, 500);
		},
		async connectThisGateway() {
			try {
				this.loading = true;
				let safeData = JSON.stringify(this.userGateway);
				let data = JSON.parse(safeData);
				data.config = JSON.stringify(this.userGatewayConfig);
				data.gateway = null;

				let result = await this.connectGateway(this.userGateway.gateway_id, data);
				if (result.status === 200) {
					this.openUrl(result.data.goto, result.data.user_gateway_id);
				} else {
					throw result
				}
			}catch (e) {
				this.$notify({
					group: 'main',
					title: e.data,
					type: 'error',
				});
				console.error("error", e)
			} finally {
				this.loading = false;
			}
		},
		async afterConnection(id) {
			try {
				let self = this;
				let result = await this.getUserGateways(id);
				if (result.status === 200) {
					let item = result.data;
					if (!self.currentGroup.user_gateways) { // if empty can be null
						self.$set(self.currentGroup, "user_gateways", [item]);
					} else
						self.currentGroup.user_gateways.push(item);
					self.goBack();
				} else {
					throw result;
				}
			} catch (e) {
				this.$notify({
					group: 'main',
					title: e.data || "Something went wrong!",
					type: 'error',
				});
				console.error("error:", e);
			} finally {
				this.loadingConnection = false;
			}
		},
		async disconnectThisGateway() {
			try {
				this.loading = true;
				let safeData = JSON.stringify(this.userGateway);
				let data = JSON.parse(safeData);
				data.config = JSON.stringify(this.userGatewayConfig);
				data.gateway = null;
				let self = this;

				await this.disconnectGateway(this.userGateway.gateway_id, this.userGateway.id, data);
				let target = self.currentGroup.user_gateways.findIndex(item => item.id === self.userGateway.id)
				self.currentGroup.user_gateways.splice(target, 1);
				self.goBack();
			} catch (e) {
				this.$notify({
					group: 'main',
					title: "Something went wrong! try again.",
					type: 'error',
				});
				console.error(e)
			} finally {
				this.loading = false;
			}
		},
	}
}
</script>

<style lang="scss" scoped>

.connect_to_stripe_box {
	position: relative;
	padding: 15px;
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	align-items: center;
	border: 1px solid #4368E0;

	.btn {
		display: flex;
		align-items: center;
		padding: 10px 15px;
		svg {
			margin-right: 10px;
		}
	}

	.disconect_btn {
		position: absolute;
		right: 5px;
		top: 5px;
		color: red !important;
		padding: 3px 10px;
		border: 1px solid red !important;
		border-radius: 3px;
		font-size: 12px;

		&:hover {
			color: #fff !important;
			background: red !important;
		}
	}

}

</style>
